import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ApplicationForm from '@/components/ApplicationForm';
import BreadcrumbJsonLd from '@/components/BreadcrumbJsonLd';

const JobApplication: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white dark:bg-[#0a0a0f]">
      <BreadcrumbJsonLd crumbs={[
        { name: 'Home', item: '/' },
        { name: 'Careers', item: '/careers' },
        { name: 'Apply' },
      ]} />
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-8 bg-gradient-to-br from-slate-50 to-blue-50 dark:from-[#0a0a0f] dark:to-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            onClick={() => navigate('/careers')}
            className="flex items-center gap-2 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Careers
          </button>
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 dark:text-white leading-tight">
              Apply to Join Adventive
            </h1>
            <p className="mt-6 text-xl text-slate-600 dark:text-slate-400">
              We're excited to learn more about you. Please fill out the form below and we'll be in touch.
            </p>
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center">
            <div className="w-full max-w-4xl">
              <div className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 p-4 sm:p-8 lg:p-12 shadow-xl shadow-slate-200/50 dark:shadow-black/30">
                <ApplicationForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default JobApplication;
